import { Navigate, useParams } from "react-router-dom"

// Legacy deep-link shims. business-v2 had standalone /tournaments/[id]/draw,
// /live, and /results routes whose only job was to client-redirect into the
// detail page with the matching ?tab=. In react-router we express that as a
// <Navigate replace> that reads :id from the URL and rewrites to the canonical
// tab URL — preserving every old bookmark/link target.
export function TournamentTabRedirect({ tab }: { tab: "entries" | "draws" | "bracket" | "winners" }) {
  const { id } = useParams<{ id: string }>()

  if (!id) {
    return <Navigate to="/tournaments" replace />
  }

  return <Navigate to={`/tournaments/${id}?tab=${tab}`} replace />
}
